module.exports = __webpack_public_path__ + "static/fun-time/games/page006_game1/audio//M_Well done.mp3";